export const UPDATE_SITEDETAILS = 'UPDATE_SITEDETAILS';
export const UPDATE_LESS_SITEDETAILS = 'UPDATE_LESS_SITEDETAILS';
export const UPDATECHECKBOXVALUE = 'UPDATECHECKBOXVALUE';
export const UPDATEVALIDATION = 'UPDATEVALIDATION';
export const UPDATENEXTSTEPSTATUE = 'UPDATENEXTSTEPSTATUE';
export const SAVEREMOVALDETAILS = 'SAVEREMOVALDETAILS';
export const SAVEFORMVALUES = 'SAVEFORMVALUES';
export const SAVERETRIEVERELOCATIONPLANDETAILS = 'SAVERETRIEVERELOCATIONPLANDETAILS';
export const SAVERELOCATIONSERVICEID = 'SAVERELOCATIONSERVICEID';
export function updateSiteDetails(site) {
    return {
        type: UPDATE_SITEDETAILS,
        data: site
    }
}
export function updateLessSiteDetails(site) {
    return {
        type: UPDATE_LESS_SITEDETAILS,
        data: site
    }
}
export function updateCheckBoxValue(obj) {
    return {
        type: UPDATECHECKBOXVALUE,
        data: obj
    }
}
export function updateValidation(details) {
    return {
        type: UPDATEVALIDATION,
        data: details
    }
}
export function updateNextStepStatue(statue) {
    return {
        type: UPDATENEXTSTEPSTATUE,
        data: statue
    }
}
export function saveRemovalDetails(details) {
    return {
        type: SAVEREMOVALDETAILS,
        data: details
    }
}
export function saveFormValues(values) {
    return {
        type: SAVEFORMVALUES,
        data: values
    }
}
export function saveRetrieveRelocationPlanDetails(details){
    return {
        type: SAVERETRIEVERELOCATIONPLANDETAILS,
        data: details
    }
}
export function saveRelocationServiceId(details){
    return {
        type: SAVERELOCATIONSERVICEID,
        data: details
    }
}